import { FaGoogle, FaInstagram, FaTiktok } from 'react-icons/fa';
import MegaphoneIcon from './MegaphoneIcon';

export const TikTokIcon = FaTiktok;
export const GoogleIcon = FaGoogle;
export const InstagramIcon = FaInstagram;
export { MegaphoneIcon };
